import { Line, Lines, Point, Points } from "ixfx/geometry"
import { Polar } from 'ixfx/geometry.js';
import { scale } from "ixfx/numbers";
export type PolarRay = Readonly<{
  /**
   * Angle of ray
   */
  angleRadian: number
  /**
   * Start point of ray, from origin
   */
  start: number
  /**
   * Length of ray
   */
  length: number
}>

export const toCartesian = (ray: PolarRay, origin: Point = Points.Empty): Line => {
  const a = Polar.toCartesian(ray.start, ray.angleRadian, origin);
  const b = Polar.toCartesian(ray.start + ray.length, ray.angleRadian, origin);
  return { a, b }
}

export const updateSvgPosition = (el: SVGLineElement, ray: PolarRay) => {
  const l = toCartesian(ray);
  el.setAttribute(`x1`, l.a.x.toString());
  el.setAttribute(`y1`, l.a.y.toString());
  el.setAttribute(`x2`, l.b.x.toString());
  el.setAttribute(`y2`, l.b.y.toString());
}

export const fromSvgPosition = (el: SVGLineElement, origin: Point): PolarRay => {
  const l = getLineFromSvg(el);
  return fromLine(l, origin);
}

const piPi = Math.PI * 2

function getAngle(a: Point, b: Point) {
  let angle = Math.atan2(b.y - a.y, b.x - a.x);// * (180 / Math.PI) + 90;
  return angle;//return (angle < 0) ? scale(angle, -90, 0, 0, piPi) : angle;
}

export const toString = (ray: PolarRay): string => {
  return `PolarRay(angle: ${ ray.angleRadian } start: ${ ray.start } len: ${ ray.length })`
}

export const fromLine = (l: Line, origin: Point): PolarRay => {
  return {
    angleRadian: Lines.angleRadian(l.b, origin),
    start: Points.distance(l.a, origin),
    length: Points.distance(l.b, l.a)
  }
}
export const getLineFromSvg = (el: SVGLineElement): Line => {
  const a = { x: el.x1.baseVal.value, y: el.y1.baseVal.value };
  const b = { x: el.x2.baseVal.value, y: el.y2.baseVal.value };
  return { a, b }
}